/**
 * Created by adalto on 4/8/14.
 */


Greenmile.ConfigInfoMarkerTruck = Greenmile.ConfigInfoMarkerTruck || {};

Greenmile.ConfigInfoMarkerTruck.Utils = {

    options: {
        EQUIPMENT: {
            value: 'EQUIPMENT',
            content: function () {
                return Monet.I18n.getResourcesByKey('Toolbar.infoMarkerTruck.equipment');
            }
        },
        DRIVER: {
            value: 'DRIVER',
            content: function () {
                return Monet.I18n.getResourcesByKey('Toolbar.infoMarkerTruck.driverFullInfo');
            }
        },
        DRIVER_NAME: {
            value: 'DRIVER_NAME',
            content: function () {
                return Monet.I18n.getResourcesByKey('Toolbar.infoMarkerTruck.driverName');
            }
        },
        DRIVER_KEY: {
            value: 'DRIVER_KEY',
            content: function () {
                return Monet.I18n.getResourcesByKey('Toolbar.infoMarkerTruck.driverKey');
            }
        },
        ROUTE: {
            value: 'ROUTE',
            content: function () {
                return Monet.I18n.getResourcesByKey('Toolbar.infoMarkerTruck.route');
            }
        },
        ROUTE_DRIVER_NAME: {
            value: 'ROUTE_DRIVER_NAME',
            content: function () {
                return Monet.I18n.getResourcesByKey('Toolbar.infoMarkerTruck.routeDriverName');
            }
        }
    }
};
